var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"a","d":"M0 0h36v36H0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"d":"M13.95 26.9605v.113l-.0473-.0453L2.25 36h31.41l-11.655-8.9718-.0247.0226v-.0903H13.95zM0 33.8079c0 .4972.18.9492.45 1.3107l11.9925-9.2203L0 16.339v17.469zm23.4653-7.9096l12.0397 9.2655c.2925-.3841.495-.8361.495-1.3559V16.2712l-12.5347 9.6271zM4.5 0v17.9209l9.54 7.774h7.8525L31.5 17.921v-6.7797H20.25V0H4.5zm17.9325 0v8.9492H31.5v-.0678L22.6328 0h-.2003z","fill":"currentColor","mask":"url(#b)","key":1})])]);
}

Email.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Email;

Email.default = Email;
